import { ajaxController } from "./controller/AjaxController";
import { clientMutationOptions } from "./controller/clientMutation";
import { PagedResult } from "../DTOs/Common/PagedResult";
import { MeterType } from "../DTOs/apiEnums.generated";
import {
  OperationMeterDTO,
  PlantMeterDTO,
  PlantMeterSetting,
  RigMetersDTO,
  RigServiceDueDTO,
  SaveOperationMeterRequest
} from "../DTOs/DrillBlast/RigMeterDTO";

class RigMetersAjax {
  private _ajaxController = ajaxController;
  private _endpoint = "/RigMeters";

  public getServiceDue() {
    return this._ajaxController.get<PagedResult<RigServiceDueDTO>>(`${this._endpoint}/service-due`, {});
  }

  public getOperationMeters(operationId: number) {
    return this._ajaxController.get<RigMetersDTO>(`${this._endpoint}/operation/${operationId}`, {});
  }

  public saveOperationMeter(operationId: number, meterType: MeterType, request: SaveOperationMeterRequest, clientId?: string) {
    return this._ajaxController.put<SaveOperationMeterRequest, OperationMeterDTO>(
      `${this._endpoint}/operation/${operationId}/${meterType}`,
      request,
      clientMutationOptions(clientId)
    );
  }

  public getPlantMeters(plantId: number) {
    return this._ajaxController.get<PagedResult<PlantMeterDTO>>(`${this._endpoint}/plant/${plantId}`, {});
  }

  public savePlantMeters(plantId: number, meters: PlantMeterSetting[]) {
    return this._ajaxController.put<PlantMeterSetting[], PlantMeterDTO[]>(`${this._endpoint}/plant/${plantId}`, meters);
  }

  public recordService(plantId: number, meterType: MeterType, servicedOn: string, reading?: number | null) {
    return this._ajaxController.post<{ servicedOn: string; reading?: number | null }, PlantMeterDTO>(
      `${this._endpoint}/plant/${plantId}/service/${meterType}`,
      { servicedOn, reading }
    );
  }
}

export const rigMetersAjax = new RigMetersAjax();
